'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
/**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Copyright (c) 2018-present, Leap DAO (leapdao.org)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This source code is licensed under the GNU Affero General Public License,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * version 3, found in the LICENSE file in the root directory of this source
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * tree.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */


var _ethereumjsUtil = require('ethereumjs-util');

var _merkleTree = require('./merkleTree');

var _merkleTree2 = _interopRequireDefault(_merkleTree);

var _block = require('./block');

var _block2 = _interopRequireDefault(_block);

var _util = require('./util');

var _helpers = require('./helpers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Period = function () {
  function Period(prevHash, blocks) {
    var _this = this;

    _classCallCheck(this, Period);

    this.prevHash = prevHash;
    this.blockList = [];
    this.blockHashList = [];

    if (blocks) {
      blocks.forEach(function (block) {
        return _this.addBlock(block);
      });
    }
  }

  _createClass(Period, [{
    key: 'addBlock',
    value: function addBlock(block) {
      if (this.blockHashList.indexOf(block.hash()) > -1) {
        throw Error('block already contained');
      }

      this.blockList.push(block);
      this.blockHashList.push(block.hash()); // invalidate existing tree
      // todo: optimize not to recalculate the whole tree on every tx added

      this.merkleTree = null;
      return this;
    }
  }, {
    key: 'getMerkleTree',
    value: function getMerkleTree() {
      if (this.blockList.length === 0) {
        throw Error('no blocks contained');
      }

      if (!this.merkleTree) {
        var hashBufs = this.blockList.map(function (block) {
          if (block.txList.length === 0) {
            return Buffer.alloc(32, 0);
          }

          return block.getMerkleTree().getRoot();
        });
        this.merkleTree = new _merkleTree2.default(hashBufs);
      }

      return this.merkleTree;
    }
  }, {
    key: 'merkleRoot',
    value: function merkleRoot() {
      return this.getMerkleTree().getHexRoot();
    }
  }, {
    key: 'setValidatorData',
    value: function setValidatorData(slotId, ownerAddr) {
      this.slotId = slotId;
      this.ownerAddr = (0, _ethereumjsUtil.toBuffer)(ownerAddr);
    }
  }, {
    key: 'periodData',
    value: function periodData() {
      if (typeof this.slotId === 'undefined' || !this.ownerAddr) {
        throw Error('period is missing validator data to create period root.');
      } // make casRoot


      var rootBuf = Buffer.alloc(64, 0);
      rootBuf.writeUInt8(this.slotId, 11);
      this.ownerAddr.copy(rootBuf, 12);
      var validatorRoot = (0, _ethereumjsUtil.keccak256)(rootBuf);
      rootBuf = Buffer.alloc(64, 0);
      validatorRoot.copy(rootBuf, 32);
      var casRoot = (0, _ethereumjsUtil.keccak256)(rootBuf); // make consensusRoot

      var blocksRoot = this.getMerkleTree().getRoot();
      rootBuf = Buffer.alloc(64, 0);
      blocksRoot.copy(rootBuf);
      var consensusRoot = (0, _ethereumjsUtil.keccak256)(rootBuf); // make period root

      rootBuf = Buffer.alloc(64, 0);
      consensusRoot.copy(rootBuf);
      casRoot.copy(rootBuf, 32);
      var periodRoot = (0, _ethereumjsUtil.bufferToHex)((0, _ethereumjsUtil.keccak256)(rootBuf));
      return {
        casRoot: casRoot,
        periodRoot: periodRoot
      };
    }
  }, {
    key: 'periodRoot',
    value: function periodRoot() {
      var _periodData = this.periodData(),
          periodRoot = _periodData.periodRoot;

      return periodRoot;
    }
  }, {
    key: 'proof',
    value: function proof(tx) {
      var blockPos = void 0;
      var periodPos = -1;

      for (var i = 0; i < this.blockList.length; i++) {
        var pos = this.blockList[i].txHashList.indexOf(tx.hash());

        if (pos >= 0) {
          if (periodPos >= 0) {
            throw Error('tx doublespend');
          }

          blockPos = pos;
          periodPos = i;
        }
      }

      if (blockPos < 0) {
        throw Error('tx not in this period');
      } // get block proof in period


      var blockProof = this.getMerkleTree().getProof(this.blockList[periodPos].getMerkleTree().getRoot()).map(function (buff) {
        return (0, _ethereumjsUtil.bufferToHex)(buff);
      }); // get tx proof in block

      var proof = this.blockList[periodPos].proof(tx, periodPos); // merge blocks proof into tx proof

      blockProof.forEach(function (elem) {
        return proof.push(elem);
      }); // add extensible proof structure

      var _periodData2 = this.periodData(),
          casRoot = _periodData2.casRoot,
          periodRoot = _periodData2.periodRoot; // update the proof


      proof.push((0, _ethereumjsUtil.bufferToHex)(Buffer.alloc(32, 0)));
      proof.push((0, _ethereumjsUtil.bufferToHex)(casRoot));
      proof[0] = periodRoot;
      return proof;
    }
    /**
      * Creates new Period with all the blocks from the given interval.
      *
      * @param {ExtendedWeb3} plasma instance of Leap Web3 or Leap Ethers
      * @param {Number} startBlock first block to include in the period
      * @param {Number} endBlock last block to include in the period
      * @returns {Period} period
      */

  }], [{
    key: 'periodForBlockRange',
    value: function periodForBlockRange(plasma, startBlock, endBlock) {
      return Promise.all((0, _util.range)(startBlock, endBlock).map(function (n) {
        return (plasma.eth || plasma).getBlock(n, true);
      })).then(function (blocks) {
        var blockList = blocks.filter(function (a) {
          return !!a;
        }).map(function (_ref) {
          var number = _ref.number,
              timestamp = _ref.timestamp,
              transactions = _ref.transactions;
          return _block2.default.from(number, timestamp, transactions);
        });
        return new Period(null, blockList);
      });
    }
    /**
      * Creates {Period} where given tx was included.
      *
      * @param {ExtendedWeb3} plasma instance of Leap Web3
      * @param {Transaction} tx transaction to create {Period} for
      * @returns {Period} period
      */

  }, {
    key: 'periodForTx',
    value: function periodForTx(plasma, tx) {
      var blockNumber = tx.blockNumber;

      var _periodBlockRange = (0, _helpers.periodBlockRange)(blockNumber),
          _periodBlockRange2 = _slicedToArray(_periodBlockRange, 2),
          startBlock = _periodBlockRange2[0],
          endBlock = _periodBlockRange2[1];

      return Period.periodForBlockRange(plasma, startBlock, endBlock);
    }
  }]);

  return Period;
}();

exports.default = Period;
module.exports = exports['default'];